import { createSelector } from 'reselect';

export const getOrganizationsState = (state) => state.organizations;

export const selectAdminOrganizationsList = createSelector(
    [getOrganizationsState],
    (organizations) => organizations.adminOrganizations.data
);

export const selectMemberOrganizationsList = createSelector(
    [getOrganizationsState],
    (organizations) => organizations.memberOrganizations.data
);
